import { useState } from 'react';

type ConfirmationReviewProps = {
  isOpen: boolean;
  title: string;
  currentValue: string;
  proposedValue: string;
  impact: string;
  actor: string;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
};

export function ConfirmationReview({ isOpen, title, currentValue, proposedValue, impact, actor, onConfirm, onCancel }: ConfirmationReviewProps) {
  const [reason, setReason] = useState("");
  if (!isOpen) return null;
  return (
    <>
      <div className="drawer-scrim is-open" onClick={onCancel} aria-hidden="true" />
      <div className="confirmation-modal" role="dialog" aria-modal="true" aria-labelledby="confirm-title">
        <h2 id="confirm-title">{title}</h2>

        <div className="confirmation-details">
          <div className="detail-row">
            <strong>Current:</strong> <span>{currentValue}</span>
          </div>
          <div className="detail-row">
            <strong>Proposed:</strong> <span>{proposedValue}</span>
          </div>
          <div className="detail-row impact-warning">
            <strong>Impact:</strong> <span>{impact}</span>
          </div>
          <div className="detail-row">
            <strong>Actor:</strong> <span>{actor}</span>
          </div>
        </div>

        <label className="reason-input">
          <span>Reason (optional):</span>
          <textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Provide operational context..." />
        </label>

        <div className="confirmation-actions">
          <button className="button" type="button" onClick={onCancel}>Cancel</button>
          <button className="button button--primary" type="button" onClick={() => onConfirm(reason)}>Confirm Change</button>
        </div>
      </div>
    </>
  );
}
